import { Box, Button, Grid, Typography } from "@mui/material";
import { getWellConfig } from "../../utils/wellsConfig";
import { useState } from "react";
import { ProgressDialog } from "./progressPopup";
import axios from "../../utils/axiosInstance";
import { getUIDescription } from "../SiteAdmin/customerGroupDetails/AssigningCustomerGroupDevice";

export const RenderTimesTab = ({
  runTimes,
  setLoading,
  selectedTab,
  selectedDevice,
  refreshData,
}) => {
  const [progressOpen, setProgressOpen] = useState(false);
  const [progressSuccess, setProgressSuccess] = useState(false);
  const [progressError, setProgressError] = useState("");

    const handleSubmitResetRuntimes = async () => {
    if (!selectedDevice?.id) {
      console.error("❌ No device selected");
      return;
    }
    // Step 1: Open dialog first
    setProgressOpen(true);
    setProgressSuccess(false);
    // Step 2: Give React a chance to render before doing heavy work
    setTimeout(() => {
      resetRuntimes();
    }, 100); // 100ms is enough to show the dialog
  };

  const resetRuntimes = async () => {
    let pollInterval = null;

    const stopPolling = () => {
      if (pollInterval) {
        clearInterval(pollInterval);
        pollInterval = null;
      }
    };

    const pollForTimeChange = ({
      unitId,
      registerList,
      lastTime,
      durationMs,
      intervalMs,
      onSuccess,
      onTimeout,
    }) => {
      const start = Date.now();

      pollInterval = setInterval(async () => {
        try {
          const resp = await axios.post(
            `${process.env.REACT_APP_API_GATEAWAY}/iot/device_get_by_register/${unitId}`,
            registerList
          );

          const currentTime = Number(resp.data.data?.time || 0);

          console.log("⏳ Polling...", { lastTime, currentTime });

          if (currentTime && currentTime !== lastTime) {
            stopPolling();
            console.log("🔄 Device time changed:", lastTime, "->", currentTime);
            onSuccess(currentTime);
          }

          if (Date.now() - start >= durationMs) {
            stopPolling();
            onTimeout();
          }
        } catch (err) {
          console.warn("Polling error:", err.message);
        }
      }, intervalMs);
    };
    try {
      let cmd = "A";
      const unitId = selectedDevice?.id;
      const wellConfig = await getWellConfig(selectedTab);
      let registerList = ["_"+wellConfig.RESET_RUNTIMES];
      // Step 1: get initial time
      const initialResp = await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/iot/device_get_by_register/${unitId}`,
        registerList
      );
      console.log("registerList", registerList)
      let lastTime = Number(initialResp.data.data?.time || 0);
      console.log("Initial time:", lastTime);
      cmd += "," + (wellConfig.RESET_RUNTIMES - 40001) + ",1";
      // === Step 2: Send plunger command ===
      await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/iot/control/precision/plg`,
        { unitId, cmd,UI_Description: `${getUIDescription()}\n Send Command to the controller \nCmd: ${cmd}`,},
        {
          headers: {
            id: "anything",
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Sending command:", cmd);
      console.log("🟡 Polling for 30s...");
      // === Step 3: poll DURING 30s ===
      pollForTimeChange({
        unitId,
        registerList,
        lastTime,
        durationMs: 30000,
        intervalMs: 4000,

        onSuccess: () => {
          console.log("✅ Runtimes reset after A command");
          setProgressSuccess(true);
        },

        onTimeout: async () => {
          console.log("⏰ No change after A, sending P command...");

          // === Step 4: build & send P ===
          let pCmd = cmd.replace("A", "P");
          pCmd = pCmd.replace(/(-?\d+),\s*(?:-?\d+(?:\.\d+)?|NaN)/gi, "$1,1");
          pCmd += `,${wellConfig.STATE - 40001},1`;

          await axios.post(
            `${process.env.REACT_APP_API_GATEAWAY}/iot/control/precision/plg`,
            { unitId, cmd: pCmd,UI_Description: `${getUIDescription()}\n Send Command to the controller \nCmd: ${pCmd}`,},
            {
              headers: {
                id: "anything",
                "Content-Type": "application/json",
              },
            }
          );
          console.log("pCmd", pCmd)
          console.log("🟢 P command sent, polling again...");

          // === Step 5: poll AFTER P ===
          pollForTimeChange({
            unitId,
            registerList,
            lastTime,
            durationMs: 170000,
            intervalMs: 4000,

            onSuccess: () => {
              console.log("✅ Runtimes reset after P command");
              setProgressSuccess(true);
            },

            onTimeout: () => {
              console.warn("❌ Timeout after P command");
              setProgressError(
                "⏰ Timeout waiting for device response. Please try again."
              );
            },
          });
        },
      });
    } catch (err) {
      console.error("plgSendCommand failed:", err);
      setProgressOpen(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid sx={{ bgcolor: "#374151", p: 2, flex: 1 }}>
      <Grid
        container
        spacing={2}
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          mb: 2,
        }}
      >
        <Button
          variant="contained"
          color="primary"
          sx={{ fontSize: 12 }}
          onClick={() =>
            handleSubmitResetRuntimes()
          }
        >
          Reset Runtimes
        </Button>
      </Grid>
      {/* Summary rows */}
      <Grid
        container
        spacing={2}
        sx={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Grid size={{ xs: 12, md: 12, lg: 3 }}>
          {runTimes.columnOne.map((row, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                borderBottom: "1px solid #a0a0a0ff",
                py: 0.6,
              }}
            >
              <Typography
                sx={{ color: "#ffffffff", fontWeight: 600, fontSize: 13 }}
              >
                {row.label}
              </Typography>
              <Typography
                sx={{ color: "#c3daffff", fontWeight: 600, fontSize: 13 }}
              >
                {row.value}
              </Typography>
            </Box>
          ))}
        </Grid>
        <Grid size={{ xs: 12, md: 12, lg: 3 }}>
          {runTimes.columnTwo.map((row, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                borderBottom: "1px solid #a0a0a0ff",
                py: 0.6,
              }}
            >
              <Typography
                sx={{ color: "#ffffffff", fontWeight: 600, fontSize: 13 }}
              >
                {row.label}
              </Typography>
              <Typography
                sx={{ color: "#c3daffff", fontWeight: 600, fontSize: 13 }}
              >
                {row.value}
              </Typography>
            </Box>
          ))}
        </Grid>
        <Grid size={{ xs: 12, md: 12, lg: 3 }}>
          {runTimes.columnThree.map((row, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                borderBottom: "1px solid #a0a0a0ff",
                py: 0.6,
              }}
            >
              <Typography
                sx={{ color: "#ffffffff", fontWeight: 600, fontSize: 13 }}
              >
                {row.label}
              </Typography>
              <Typography
                sx={{ color: "#c3daffff", fontWeight: 600, fontSize: 13 }}
              >
                {row.value}
              </Typography>
            </Box>
          ))}
        </Grid>
      </Grid>
      {/* Runs (2 columns of 12) */}
      <Grid
        container
        spacing={{ xs: 0, lg: 4 }}
        sx={{
          mt: 2,
        }}
      >
        <Grid size={{ xs: 12, md: 12, lg: 6 }}>
          {runTimes.runTimesLeft.map((run) => (
            <Box
              key={run.label}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                py: 0.6,
                borderBottom: "1px solid #a0a0a0ff",
              }}
            >
              <Typography
                sx={{ color: "#ffffffff", fontWeight: 600, fontSize: 13 }}
              >
                {run.label}
              </Typography>
              <Typography
                sx={{ color: "#c3daffff", fontWeight: 600, fontSize: 13 }}
              >
                {run.value}
              </Typography>
            </Box>
          ))}
        </Grid>
        <Grid size={{ xs: 12, md: 12, lg: 6 }}>
          {runTimes.runTimesRight.map((run) => (
            <Box
              key={run.label}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                py: 0.6,
                borderBottom: "1px solid #a0a0a0ff",
              }}
            >
              <Typography
                sx={{ color: "#ffffffff", fontWeight: 600, fontSize: 13 }}
              >
                {run.label}
              </Typography>
              <Typography
                sx={{ color: "#c3daffff", fontWeight: 600, fontSize: 13 }}
              >
                {run.value}
              </Typography>
            </Box>
          ))}
        </Grid>
      </Grid>
      <ProgressDialog
        open={progressOpen}
        isSuccess={progressSuccess}
        errorMessage={progressError}
        onClose={() => {
          setProgressOpen(false);
          setProgressError("");
        }}
        onRefresh={async () => {
          setProgressOpen(false);
          setProgressError("");
          await refreshData();
        }}
        loadingMessage="Check Device Response. Operation in-progress ..."
        successMessage="Successfully updated!"
      />
    </Grid>
  );
};
